// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseComment } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComment';
import { APPComponent } from './APPComponent';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 注释 实体类
 * 注释
 */
export class APPComment extends BaseComment {
  /** 应用组件 的ID */
  private _component_ID: string;

  /** 获取：应用组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：应用组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 应用组件  */
  private _component: APPComponent;

  /** 获取：应用组件  */
  public get component() {
    return this._component;
  }

  /** 设置：应用组件  */
  public set component(value: APPComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  constructor() {
    super();
    this._component_ID = '';
    this._component = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: APPComment, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = APPComponent.Create(json.Component);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): APPComment {
    const aPPComment = new APPComment();
    aPPComment.Deserialize(json);
    aPPComment.json = json;
    return aPPComment;
  }
}
